module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-9-8b9c324b5b2f6ddef794738c45eff72c.jpg";